import { AHIconType, useLayoutContext, useTheme } from "arkh";
import React from "react";
import { TeamHeaderButton } from "../../../Team/TeamHomeNavigator/TeamHome/TeamHeader/TeamHeaderButton";

export function HeaderProminentButton(props: {
  onPress(): void;
  title: string;
  icon?: AHIconType;
}) {
  const layout = useLayoutContext();
  const theme = useTheme();
  return (
    <TeamHeaderButton
      title={props.title}
      icon={props.icon}
      tintColor="text-inverted"
      onPress={props.onPress}
      itemStyle={{
        paddingHorizontal: layout.space.small,
        backgroundColor: theme.primary,
      }}
    />
  );
}
